import React from 'react'
import BaseSelect from 'react-select'
import BaseCreatableSelect from 'react-select/creatable'
import IconButton from '@mui/material/IconButton'
import DeleteIcon from '@mui/icons-material/Delete'
import { styled } from '@mui/material/styles'
import { Box, Typography } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { removedOptionSetAction } from '../../../store/pages/common/update'
import { updateOptionSet } from '../../../store/pages/common/formulaDialog'

import {
  SingleValue,
  SingleValueStyles,
  AppendColumnBuilder
} from '../../../components/sql/SelectSingleValue'

const Select = styled(BaseSelect)(({ theme }) => ({
  minHeight: 58,
  margin: theme.spacing(1)
}))

const CreatableSelect = styled(BaseCreatableSelect)(({ theme }) => ({
  minHeight: 58,
  margin: theme.spacing(1)
}))

const DeleteButton = styled(IconButton)({
  marginTop: 15
})

const SetRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  marginBottom: '12px',
  flexWrap: 'nowrap',
  width: '100%',
  overflowX: 'hidden'
})

export default function SetList () {
  const dispatch = useDispatch()

  const navigation = useSelector(store => store.navigation)
  const update = useSelector(store => store.update)

  const { columns } = navigation.file

  const columnOptions = React.useMemo(
    () =>
      columns.map(column => ({
        value: column.Name,
        label: column.Name
      })),
    [columns]
  )

  const allColumnOptions = React.useMemo(
    () =>
      AppendColumnBuilder(columns).map(column => ({
        value: column.Name,
        label: column.Name
      })),
    [columns]
  )

  return (
    <Box width="100%">
      {update.updateSetConditions.map((item, index) => (
        <SetRow key={index}>
          <Box sx={{ flex: '1 1 25%' }}>
            <Select
              menuPosition='fixed'
              placeholder=""
              name={`column-${index}!`}
              styles={SingleValueStyles}
              value={item.columnName}
              queryIndex={index}
              queryTarget="updateSetConditions"
              queryKey="columnName"
              components={{ SingleValue }}
              options={columnOptions}
              onChange={value =>
                dispatch(updateOptionSet('columnName', index, value))
              }
            />
          </Box>

          <Box sx={{ flex: '0 0 auto' }}>
            <Typography fontSize={32}>{item.operation}</Typography>
          </Box>

          <Box sx={{ flex: '1 1 30%' }}>
            <CreatableSelect
              menuPosition='fixed'
              placeholder=""
              name={`where-${index}!`}
              styles={SingleValueStyles}
              value={item.whereValue}
              queryIndex={index}
              queryTarget="updateSetConditions"
              queryKey="whereValue"
              components={{ SingleValue }}
              options={allColumnOptions}
              onChange={value =>
                dispatch(updateOptionSet('whereValue', index, value))
              }
            />
          </Box>

          <Box sx={{ flex: '0 0 auto' }}>
            <DeleteButton
              size="large"
              onClick={() =>
                dispatch({ ...removedOptionSetAction, payload: index })
              }
            >
              <DeleteIcon data-testid="DeleteIcon" />
            </DeleteButton>
          </Box>
        </SetRow>
      ))}
    </Box>
  )
}
